import React from 'react';
import ReactDOM from 'react-dom';
import './index.css'; // Import global CSS (linked via public/index.html)
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
